const RAW_ACTION_TYPES = {
  LOAD_RAWS: 'role/LOAD_RAWS',
};

export default RAW_ACTION_TYPES;
